import api from 'api';
import Poster from 'records/Poster';

export const POSTER_ITEM_ASYNC_ACTION_START = 'POSTER_ITEM_ASYNC_ACTION_START';
export const POSTER_ITEM_ASYNC_ACTION_ERROR = 'POSTER_ITEM_ASYNC_ACTION_ERROR';
export const POSTER_ITEM_ASYNC_ACTION_SUCCESS = 'POSTER_ITEM_ASYNC_ACTION_SUCCESS';
export const POSTER_ITEM_ASYNC_UPDATE_ACTION_SUCCESS = 'POSTER_ITEM_ASYNC_UPDATE_ACTION_SUCCESS';
export const POSTER_ITEM_RESET_STATE = 'POSTER_ITEM_RESET_STATE';

function posterAsyncActionStart() {
  return {
    type: POSTER_ITEM_ASYNC_ACTION_START,
  };
}

function posterAsyncActionSuccess(data) {
  return {
    type: POSTER_ITEM_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function posterAsyncActionError(error) {
  return {
    type: POSTER_ITEM_ASYNC_ACTION_ERROR,
    error,
  };
}


function posterAsyncUpdateSuccess(data) {
  return {
    type: POSTER_ITEM_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}


export function resetDesignItemState() {
  return {
    type: POSTER_ITEM_RESET_STATE,
  };
}

export function getPosterAsync(designid) {
  return (dispatch, getState) => {
    dispatch(posterAsyncActionStart());
    return api.request(`design/poster?designId=${ designid }`, 'get')
    .then((data) => {
      dispatch(posterAsyncActionSuccess(data));
      return new Poster(data);
    })
    .catch((err) => {
      dispatch(posterAsyncActionError('Unable to get poster'));
      throw (err);
    });
  };
}

export function updatePosterAsync(poster) {
  return (dispatch, getState) => {
    dispatch(posterAsyncActionStart());
    return api.request('design/poster', 'put', poster)
    .then((data) => {
      dispatch(posterAsyncUpdateSuccess(data));
      return new Poster(data);
    })
    .catch((err) => {
      dispatch(posterAsyncActionError('Unable to update poster'));
      throw (err);
    });
  };
}

export function createPosterAsync(poster) {
  return (dispatch, getState) => {
    dispatch(posterAsyncActionStart());
    return api.request('design/poster', 'post', poster)
    .then((data) => {
      dispatch(posterAsyncActionSuccess(data));
      return new Poster(data);
    })
    .catch((err) => {
      dispatch(posterAsyncActionError('Unable to create poster'));
      throw (err);
    });
  };
}
